<template>
    <div class="user-box">

        <div class="userbar">
            <div class="user-top-box">
                <div class="avatar">
                    <img class="img" src="/img/user/avatar.jpg" />
                </div>
                <p class="userName"> {{ userInfo.username }} </p>
            </div>
        </div>

        <div class="user-list">
            <van-cell v-if="isLogin" is-link @click="goTo('/gamePoints/points')" :title="$t('LAN.points')">
                <template #value>
                    {{ userInfo.points }}
                    <img src="@/assets/common/points.png" style="height: 16px" />
                </template>
            </van-cell>
            <van-cell is-link v-if="isLogin" @click="goTo('/user/password')" :title="$t('LAN.change_pwd')" />
            <van-cell is-link v-if="isLogin" @click="goTo('/user/bindemail')"
                :value="userInfo.email != '' ? userInfo.email : $t('LAN.unbound')" :title="$t('LAN.bind_email')" />
            <van-cell is-link v-if="isLogin" @click="goTo('/user/bindmobile')"
                :value="userInfo.mobile != '' ? userInfo.mobile : $t('LAN.unbound')" :title="$t('LAN.bind_mobile')" />
            <!-- <van-cell is-link @click="langPicker = true" :title="$t('LAN.default_language')" /> -->
            <van-cell is-link @click="priveShow = true" :title="$t('LAN.user_service')" />
            <!-- <van-cell is-link v-if="isLogin" @click="goTo('/user/accountdestroy')" :title="$t('LAN.account_destroy_now')" /> -->
        </div>

        <!-- 隐私政策弹窗 -->
        <van-popup v-model:show="priveShow" round :style="{ height: '90%', width: '90%', maxWidth: '580px' }">
            <iframe :src="priveUrl" frameborder="0" />
        </van-popup>

        <!-- 语言选择弹窗 -->
        <van-popup v-model:show="langPicker" round :style="{ width: '95%', maxWidth: '520px' }">
            <van-picker show-toolbar :confirm-button-text="$t('LAN.confirm')" :cancel-button-text="$t('LAN.cancel')"
                :columns="langColumns" value-key="name" @confirm="onLangConfirm" @cancel="langPicker = false" />
        </van-popup>

        <div style="margin: 16px;">
            <van-button round block color="#6e87ea" v-if="isLogin" @click="handleLogout">{{ $t('LAN.logout')
            }}</van-button>
            <van-button round block color="#6e87ea" v-if="!isLogin" @click="handleLogin">{{ $t('LAN.UserLogin')
            }}</van-button>
        </div>
        <nav-bar />
    </div>


</template>

<script>
import { reactive, onMounted, toRefs, getCurrentInstance, ref, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { requestInfo } from "@/service/user";
import { Toast, Dialog } from 'vant'
import NavBar from '@/components/NavBar'
import { useI18n } from "vue-i18n";
import { callApp } from "@/utils/common";

import {
    GLOBAL,
} from "@/configs/global";

export default {
    name: 'my',
    setup() {
        // 扩展语言
        const { proxy } = getCurrentInstance();
        const router = useRouter()
        const store = useStore()
        const active = ref(0);
        const { t } = useI18n();

        const state = reactive({
            priveShow: false,
            userInfo: {
                username: "",
                email: "",
                googleName: "",
                fbName: "",
                mobile: "",
                points: 0
            },
            lang: t("LOCAL.en_US"),
            langPicker: false,
            langColumns: [
                { name: t("LOCAL.zh_CN"), lang: "zh_CN" },
                { name: t("LOCAL.zh_TW"), lang: "zh_TW" },
                { name: t("LOCAL.en_US"), lang: "en_US" },
                { name: t("LOCAL.ko_KR"), lang: "ko_KR" },
                { name: t("LOCAL.ru_RU"), lang: "ru_RU" },
                { name: t("LOCAL.de_DE"), lang: "de_DE" },
                { name: t("LOCAL.ja_JP"), lang: "ja_JP" },
                { name: t("LOCAL.tr_TR"), lang: "tr_TR" },
                { name: t("LOCAL.pt_BR"), lang: "pt_BR" },
                { name: t("LOCAL.vi_VN"), lang: "vi_VN" },
                { name: t("LOCAL.es_LA"), lang: "es_LA" },
                { name: t('LOCAL.ar_SA'), lang: "ar_SA" }
            ],
            priveUrl: GLOBAL.PRIVE_URL,
            nickName: t('LAN.not_login'),
            accountNumber: t('LAN.unlock'),
            isLogin: false,
            pauerList: []  //玩家游戏列表
        });

        onMounted(async () => {
            init()

            //设置语言
            proxy.$I(proxy, store.getters.lang)

            state.priveUrl = state.priveUrl + "?lang=" + store.getters.lang + "&v=" + Math.random();

            window.removeEventListener("loginSuccess", init)
            window.removeEventListener("logout", init)
            window.addEventListener('loginSuccess', init, false);
            window.addEventListener('logout', init, false);
        });


        const init = async () => {
            console.log("init my info")
            state.userInfo.username = store.getters.username;
            console.log(store.getters.token)
            if (store.getters.isLogin) {
                Toast.loading(t('LAN.loading'));
                const result = await requestInfo();
                if (result) {
                    state.userInfo.username = result.username;
                    state.userInfo.email = result.email || "";
                    state.userInfo.googleName = result.googleName || "";
                    state.userInfo.fbName = result.fbName || "";
                    state.userInfo.mobile = result.mobile || "";
                    store.dispatch("updateInfo", result);
                    state.nickName = state.userInfo.username;
                    state.accountNumber = "";
                    state.userInfo.points = result.points || 0;
                    state.isLogin = true
                    Toast.clear()
                }
            } else {
                state.userInfo = {
                    username: "",
                    email: "",
                    googleName: "",
                    fbName: "",
                    mobile: "",
                    points: 0
                }
                state.isLogin = false
            }
        }

        const goTo = (url, params) => {
            router.push({ path: url, query: params })
        }

        const handleLogout = () => {
            //加一个退出提示
            Dialog.confirm({
                title: '',
                message: t('LAN.is_logout_account'),
                confirmButtonText: t('LAN.confirm'),
                cancelButtonText: t('LAN.cancel')
            })
                .then(() => {
                    document.cookie = 'test=';
                    document.cookie = 'gameId=';
                    store.dispatch('logout')

                    nextTick(() => {
                        const event = document.createEvent("HTMLEvents");
                        event.initEvent("logout", true, true);
                        window.dispatchEvent(event);
                    })

                    // store.commit("setNeedLogin", true)
                })
                .catch(() => {
                    // on cancel
                });
        }

        const handleLogin = () => {
            store.commit("setNeedLogin", true);
        }

        const onLangConfirm = (value) => {
            proxy.$I(proxy, value.lang);
            state.langPicker = false;
            state.lang = value.lang;
            state.priveUrl = state.priveUrl + "?lang=" + store.getters.lang + "&v=" + Math.random();
            callApp("updateLang", value.lang);
        };

        return {
            ...toRefs(state),
            goTo,
            onLangConfirm,
            handleLogout,
            handleLogin,
            active
        }
    },
    components: {
        NavBar,
    },
}

</script>

<style lang="less" scoped>
.pageTop {
    width: 100%;
    height: 5.06667rem;
    overflow: auto;
    background: #12cdb0;

}

.userHeader {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    height: 1.49333rem;
    background: #12cdb0;
    font-size: .37333rem;
    color: #fff;
    z-index: 100;
    display: flex;
}

.userInfo {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 89%;
    margin: auto;
    margin-top: 1.86667rem;
}

.userInfo .avatar_box {
    width: 1.52rem;
    height: 1.52rem;
    border-radius: 50%;
    background: #fff;
    border: 0.08rem solid #fff;
    box-shadow: 0.08rem 0.08rem 0.32rem 0 rgba(92, 128, 154, .2);
}

.noLoginAvator {
    -webkit-tap-highlight-color: transparent;
    --safe-top: env(safe-area-inset-top);
    --safe-bottom: env(safe-area-inset-bottom);
    --safe-left: env(safe-area-inset-left);
    --safe-right: env(safe-area-inset-right);
    font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', miui, 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
    user-select: none;
    font-size: 12px;
    --font-size-zoom: 1.00000;
    --sat: var(--safe-top);
    width: 1.52rem;
    height: 1.52rem;
    border-radius: 50%;
}

.userInfo .info {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    margin-left: 0.26667rem;
    align-items: flex-start;
}

.userInfo .info .nickName {
    font-size: .42667rem;
    font-weight: 400;
    color: #fff;
    line-height: .64rem;
}

.userInfo .info .accountNumber {
    margin-top: 0.02667rem;
    font-size: .32rem;
    font-weight: 400;
    color: #fff;
    line-height: .48rem;
    height: 0.48rem;
    display: flex;
}

.userInfo .user_enter {
    width: 0.4rem;
    height: 0.4rem;
}

.accountWrapper {
    margin: auto;
    box-sizing: border-box;
    padding: 0.37333rem 0.42667rem 0.42667rem 0.53333rem;
    width: 92%;
    height: 1.92rem;
    border-radius: 0.34667rem;
    box-shadow: 0 0 0.64rem 0 rgba(157, 185, 201, .3);
    background: #fff;
    position: relative;
    margin-top: -1.12rem;
}

.accountWrapper .account {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 29%;
    height: 100%;
}

.accountWrapper .account .info .balance {
    font-size: .4rem;
    color: #333;
    line-height: .64rem;
}

.accountWrapper .account .info .give {
    line-height: .48rem;
    font-size: .32rem;
    color: #999;
}

.accountWrapper .account .info {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
}

.accountWrapper .go_right {
    width: 0.4rem;
    height: 0.4rem;
}

.accountWrapper .voucher {
    width: 29%;
    height: 100%;
}

.accountWrapper .voucher,
.accountWrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.accountWrapper .voucher .info {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
}

.van-badge__wrapper {
    position: relative;
    display: inline-block;
}

.accountWrapper .voucher .info .name {
    line-height: .64rem;
    font-size: .4rem;
    font-weight: 400;
    color: #333;
}

.accountWrapper .voucher .info .intro {
    line-height: .48rem;
    font-size: .32rem;
    font-weight: 400;
    color: #999;
}

.user-box {
    height: calc(var(--vh, 1vh) * 100);
}

iframe {
    height: 100%;
    width: 100%;
}

.content-scroll {
    width: 100%;
}

.user-list {
    text-align: left;
}

.userbar {
    height: 200px;
    position: relative;
    overflow: hidden;
    background: #6e87ea;

    .user-top-box {
        margin: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        font-size: 18px;
    }

    .avatar {
        width: 80px;
        height: 80px;
        margin: auto;
        padding: 3px;
        border-radius: 50%;
        background-color: #fff;
        box-shadow: 0 0 5px #333;

        .img {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
    }

    p {
        text-align: center;
        color: #fff;
        letter-spacing: 2px;
    }

}

.list_item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: auto;
    //width: 8.93333rem;
    height: 2.02667rem;
    box-shadow: 0 0 0.37333rem 0 rgba(153, 177, 191, .2);
    border-radius: 0.37333rem;
    margin-bottom: 0.32rem;
    position: relative;
    margin-top: 0.21333rem;
}

.info {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-left: 0.32rem;
}

.info img {
    margin-right: 0.26667rem;
    width: 1.38667rem;
    height: 1.38667rem;
    border-radius: 0.24rem;
}

.intro .name {
    max-width: 4.64rem;
    font-size: .42667rem;
    font-weight: 400;
    line-height: .64rem;
    color: #333;
    margin-bottom: 0.08rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
}

.game_time {
    font-size: .32rem;
    font-weight: 400;
    color: #999;
    line-height: .42667rem;
}

.operate_box {
    margin-right: 0.32rem;
}

.operate_box .btn {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    min-width: 1.28rem;
    height: 0.64rem;
    border-radius: 0.42667rem;
    font-size: .26667rem;
    padding: 0 0.13333rem;
    color: #12cdb0;
    font-weight: 500;
    border: 0.032rem solid #12cdb0;
    box-sizing: border-box;
}

@media (min-width: 371px) and (max-width: 642px) {
    .accountWrapper .account {
        width: 45%;
    }

    .accountWrapper .voucher {
        width: 45%;
    }
}
</style>